import { Typography } from "@mui/material";

const HmSubHeaderTitle = ({ ...props }) => {
  const { title, sx } = props;
  let SxProps = {
    fontSize: "1.125rem",
    color: "gray",
    fontWeight: "bold",
    mt: "0.5em",
    mb: "1em",
  };
  if (sx) {
    SxProps = { ...SxProps, ...sx };
  }
  const formattedTitle = ucFirst(title).replace(/ /g, "\u00A0");
  return (
    <Typography variant="h3" sx={SxProps} className="hm-subheader-title">
      {formattedTitle}
    </Typography>
  );
};
const ucFirst = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export default HmSubHeaderTitle;
